import type { IntegrationListItemType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Alert } from "../../../../components/alert/Alert";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierRelationshipIntegrationValuesCreate } from "../../../../hooks/api/v2/supplierRelationshipIntegrationValues/useSupplierRelationshipIntegrationValuesCreate";
import { ConnectionIntegrationValuesRow } from "./ConnectionIntegrationValuesRow";

export function ConnectionIntegrationValueCreate({
  integration,
  connectionId,
}: {
  integration: IntegrationListItemType;
  connectionId: number;
}): ReactElement | null {
  const createIntegrationValueMutation =
    useSupplierRelationshipIntegrationValuesCreate();

  const onSubmit = (value: string) => {
    if (integration.id) {
      createIntegrationValueMutation.mutate({
        value,
        IntegrationId: integration.id,
        SupplierRetailerConnectionId: connectionId,
      });
    }
  };

  return (
    <>
      {createIntegrationValueMutation.isError && (
        <Alert
          type={"error"}
          message={
            apiV2AssertError(createIntegrationValueMutation.error)?.response
              ?.data.message ?? "An unknown error occurred"
          }
        />
      )}
      <ConnectionIntegrationValuesRow
        integration={integration}
        onSubmit={(e) => onSubmit(e)}
        loading={createIntegrationValueMutation.isPending}
      />
    </>
  );
}
